<header class="page-head">
  <div class="page-title">
    <span class="page-kicker">Operações</span>
    <h1>Relatórios</h1>
    <p>Seleccione um modelo, ajuste os filtros e descarregue o documento.</p>
  </div>

  <div class="report-summary" aria-label="Resumo dos relatórios disponíveis" aria-live="polite">
    <span class="summary-icon">
      <i class="pi" [class.pi-spin]="loading"
        [class.pi-spinner]="loading"
        [class.pi-file-export]="!loading"></i>
    </span>
    <div>
      @if (loading) {
        <strong>—</strong>
        <span>A carregar modelos</span>
      } @else {
        <strong>{{ reportCount }}</strong>
        <span>{{ reportCount === 1 ? 'modelo disponível' : 'modelos disponíveis' }}</span>
      }
    </div>
  </div>
</header> 